import { createContext, PropsWithChildren, useContext } from 'react';
import { BoloPanelMetadataStore } from './bolo-panel-metadata-store';

const BoloPanelMetadataContext = createContext<undefined | BoloPanelMetadataStore>(undefined);

export const BoloPanelMetadataProvider = (
    props: PropsWithChildren<{ value: BoloPanelMetadataStore }>
) => {
    return (
        <BoloPanelMetadataContext.Provider value={props.value}>
            {props.children}
        </BoloPanelMetadataContext.Provider>
    );
};

export const useBoloPanelMetadata = () => {
    const store = useContext(BoloPanelMetadataContext);
    if (!store) {
        throw new Error('Unexpectedly did not find bolo metadata object');
    }
    return store.state.metadata;
};

export const useBoloPanelMetadataStore = () => {
    const store = useContext(BoloPanelMetadataContext);
    if (!store) {
        throw new Error('Unexpectedly did not find bolo metadata object');
    }
    return store;
};
